import { InjectionToken } from '@angular/core';

/**
 * interfaces
 */
import { IUploadsApiService } from '../interfaces';

/**
 * Token for the uploads HTTP layer, so nothing depends on the concrete
 * service class.
 */
export const UPLOADS_API = new InjectionToken<IUploadsApiService>('UPLOADS_API');
